import {addSlug} from 'shared';
import {z} from 'zod';

import type {SectionMappingNode} from '../../types/forms';

export const baseMappingNodeSchema = z.object({
  sectionId: z.string(),
});

const sectionMappingNodeSchema: z.ZodType<SectionMappingNode> =
  baseMappingNodeSchema.extend({
    nodes: z.lazy(() => z.record(z.string(), sectionMappingNodeSchema)),
  });

export const layoutTemplateSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    modified: z.coerce.date(),
    map: z.record(z.string(), sectionMappingNodeSchema).nullable(),
  })
  .transform(addSlug);

export const layoutTemplateListSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    modified: z.coerce.date(),
    layerCount: z.number(),
  })
  .transform(addSlug)
  .array();

export const layoutTemplatePayloadSchema = z.object({
  name: z.string().trim().min(2).max(30),
});
